import { motion } from "framer-motion";
import { ExternalLink, Building2 } from "lucide-react";

/**
 * राजकाज is served DIRECTLY from Govt PR websites (जनसंपर्क MP / CG).
 * No RSS, no internal listing — just two big external CTAs.
 */
const LINKS = [
  {
    label: "जनसंपर्क · मध्यप्रदेश",
    tag: "MP DPR",
    href: "https://www.mpinfo.org/",
    color: "#D92525",
  },
  {
    label: "जनसंपर्क · छत्तीसगढ़",
    tag: "CG DPR",
    href: "https://dprcg.gov.in/",
    color: "#0A0F1E",
  },
];

export default function RajkajExternalBlock() {
  return (
    <section
      id="rajkaj"
      data-testid="rajkaj-external"
      className="bg-[#0A0A0A] text-[#F4F4F0] border-y border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="eyebrow text-[#D92525] mb-3">Governance · सरकारी घोषणाएँ</div>
            <h2 className="font-serif-dev font-black text-[38px] md:text-[54px] leading-[1.02]">
              जनसंपर्क <span className="italic">— सीधे स्रोत से</span>
            </h2>
            <p className="mt-4 font-sans-dev text-[15px] md:text-[16px] text-white/70 max-w-[560px] leading-relaxed">
              जनसंपर्क विभाग की आधिकारिक प्रेस विज्ञप्तियाँ, बिना किसी सम्पादन के—
              सरकार के अपने पोर्टल पर।
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {LINKS.map((l) => (
            <motion.a
              key={l.href}
              href={l.href}
              target="_blank"
              rel="noreferrer noopener"
              data-testid={`rajkaj-link-${l.tag.replace(/\s+/g, "-").toLowerCase()}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="group relative border border-white/15 bg-white/[0.04] hover:bg-white/[0.08] transition-colors p-8 md:p-10 flex flex-col justify-between min-h-[220px]"
            >
              <div>
                <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-white/60 mb-6">
                  <Building2 size={14} />
                  {l.tag}
                </div>
                <div className="font-serif-dev font-black text-[26px] md:text-[34px] leading-[1.1] group-hover:text-[#D92525] transition-colors">
                  {l.label}
                </div>
              </div>
              <div className="mt-8 flex items-center justify-between">
                <span className="font-sans-dev text-[11px] uppercase tracking-[0.24em] text-white/60">
                  आधिकारिक वेबसाइट पर जाएँ
                </span>
                <span className="w-11 h-11 rounded-full bg-white/10 group-hover:bg-[#D92525] flex items-center justify-center transition-colors">
                  <ExternalLink size={16} />
                </span>
              </div>
              <span className="absolute top-0 left-0 h-1 w-full" style={{ background: l.color }} />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
